import { createModule, mutation } from 'vuex-class-component';
import { AlertType } from '@/components/alert.component.vue';

const VuexModule = createModule({
  namespaced: 'Alert',
  strict: false,
  target: 'nuxt',
});

/** Defines the configuration options of the main alert component. */
type AlertSet = { template: string, type?: AlertType };

/** Defines all options of the main alert component. */
type AlertOptions = AlertSet & { visible: boolean };

class MainAlertStore extends VuexModule {
  private options!: AlertOptions;

  constructor() {
    super();

    this.options = {
      template: '',
      type: 'primary',
      visible: false,
    };
  }

  /**
   * Show the alert component.
   * @param options The alert options.
   */
  @mutation
  show(options: AlertSet) {
    this.options.template = options.template;
    this.options.visible = true;

    if (options.type) {
      this.options.type = options.type;
    }
  }

  /**
   * Hide the alert component.
   */
  @mutation
  hide() {
    this.options.visible = false;
  }

  /**
   * Get the configured options.
   */
  get alertOptions(): AlertOptions {
    return this.options;
  }
}

export { MainAlertStore, AlertOptions };
